import * as React from "react";
const SvgLogoutOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.588-1.412A1.93 1.93 0 0 1 5 3h6q.425 0 .713.288.288.289.287.712 0 .424-.288.713A.96.96 0 0 1 11 5H5v14h6q.425 0 .713.288T12 20t-.288.713A.96.96 0 0 1 11 21zm12.175-8H10a.97.97 0 0 1-.712-.288A.97.97 0 0 1 9 12q0-.424.288-.712A.97.97 0 0 1 10 11h7.175L15.3 9.125a.92.92 0 0 1-.275-.675q0-.4.275-.7a.95.95 0 0 1 .7-.313.94.94 0 0 1 .725.288L20.3 11.3q.3.3.3.7t-.3.7l-3.575 3.575q-.3.3-.712.288a1.02 1.02 0 0 1-.713-.313.97.97 0 0 1-.262-.712.98.98 0 0 1 .287-.688z"
    />
  </svg>
);
export default SvgLogoutOutlined;
